import React, {useState, useRef} from "react";
import http from "../../../services/http";
import { Toast } from 'primereact/toast';
import useUserData from "../../../context/user";


export default function FormUserPhoto() {

    const [photo, setPhoto] = useState('')
    const toast = useRef(null);
    const {user, updateUser} = useUserData()

    function onFileChange(e) {

        const photo = e.target.files[0]

        const formData = new FormData();
        formData.append("photo", photo);
        formData.append("uid", user.uid);

        http.post("user/photo/update/", formData).then((response) => {
            setPhoto(response.data.photo)
            updateUser()
            toast.current.show({ severity: 'success', summary: 'Sucesso', detail: 'Imagem atualizada com sucesso', life: 4000 });
        })
        .catch((error) => {
            toast.current.show({ severity: 'warn', summary: 'Ops', detail: error.response.data['detail'], life: 4000 });

        });
        
    }

    return (

        <div className="mt-2">
            
            <Toast ref={toast} position="top-right" />

            <h4>Atualizar Foto</h4>
            
            <form encType="multipart/form-data" id="formImg">
                <input type="file" name='photo' className="form-control" onChange={onFileChange} accept="image/*" />
            </form>
            
            <div className="col text-center mt-3 pt-3">
            {
                photo ?
                <>
                <img alt="logo" src={`${photo}`} className="img-fluid img-thumbnail rounded" width="80" />
                </>
                : null
            }
            </div>
        </div>

    )
}